import { FC } from 'react';

import PortalHeader from 'components/PortalHeader/PortalHeader';

type HeaderProps = {
    onGenerateReport: () => void;
};

const Header: FC<HeaderProps> = ({ onGenerateReport }) => {
    return (
        <PortalHeader
            title="Reports"
            primaryButtonText="Generate new report"
            onPrimaryButtonClick={onGenerateReport}
            isCreateButton
            dataTestId="ReportsHeader"
        />
    );
};

export default Header;

